import imgEmptyThanhToan from 'assets/images/img_emptyview_thanh_toan.png';
import AgencySaleDialogView from 'features/Agency/components/AgencySaleDialogView';
import agencySaleHelper from 'features/DealerReconciliationReport/agencySaleHelper';
import AgencyTransactionHelper from 'features/ManageAgencyTransaction/agencyTransactionHelper';
import AgencyTransactionDetailView from 'features/ManageAgencyTransaction/components/AgencyTransactionDetailView';
import DealerHelper from 'features/ManageDealer/dealerHelper';
import { AppDialogHelper } from 'general/components/AppDialog';
import { AppCustomDialogHelper } from 'general/components/AppDialogCustom';
import DropdownTableConfigColumn from 'general/components/DropdownTableConfigColumn';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTBSButton, { KTBSButtonColor, KTBSButtonSize } from 'general/components/OtherKeenComponents/KTBSButton';
import KTBSCard from 'general/components/OtherKeenComponents/KTBSCard';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import KTPagination, {
  KTPaginationColor,
} from 'general/components/OtherKeenComponents/KTPagination';
import KTTable from 'general/components/OtherKeenComponents/KTTable';
import tableStyle from 'general/components/OtherKeenComponents/KTTable/tableStyle';
import CustomDateRangePicker, { dateFilter } from 'general/components/Others/CustomDateRangePicker';
import EmptyView from 'general/components/Others/EmptyView';
import MenuActionDropdown from 'general/components/Others/MenuActionDropdown';
import AppColors from 'general/constants/AppColors';
import AppConstants from 'general/constants/AppConstants';
import AppResource from 'general/constants/AppResource';
import AppRoute from 'general/constants/AppRoute';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Global from 'general/utils/Global';
import Utils from 'general/utils/Utils';
import useAccount from 'hooks/useAccount';
import useConfigTableColumn from 'hooks/useConfigTableColumn';
import useRouter from 'hooks/useRouter';
import _ from 'lodash';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import * as ExcelJS from 'exceljs';
import agencyApi from 'api/agencyApi';
import ChargeHelper from 'features/Charge/chargeHelper';
import AgencyHelper from 'features/Agency/agencyHelper';

const defaultColumnIds = [
  'TRANSACTION_CODE',
  'AGENCY_NAME',
  'BANK_BENEFICIARY',
  'BANK_ACCOUNT',
  'BANK_NAME',
  'REQUIRE_TIME',
  'PAID_TIME',
  'AMOUNT',
  'BALANCE',
  'STATUS',
  'ROLE',
];

function AgencyTransactionListScreen(props) {
  // ---- params ----
  const router = useRouter();
  const { t } = useTranslation();
  const account = useAccount();
  const { user } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  const loadingRef = useRef(false);

  const fullColumns = useMemo(() => {
    return [
      {
        id: 'TRANSACTION_CODE',
        name: (
          <span
            className="letter-spacing-unset"
            style={{
              fontSize: 12,
              color: AppColors.gray[900],
            }}
          >
            {t('Mã giao dịch')}
          </span>
        ),
        width: '120px',
        selector: (row) => row?.paymentCode ?? row?.paymentId,
        style: tableStyle.columns.normal,
      },
      {
        id: 'AGENCY_NAME',
        name: (
          <span
            className="letter-spacing-unset"
            style={{
              fontSize: 12,
              color: AppColors.gray[900],
            }}
          >
            {t('Người yêu cầu')}
          </span>
        ),
        minWidth: '240px',
        selector: (row) => {
          return (
            <span
              className="cursor-pointer hover-opacity-60"
              onClick={() => {
                if (row?.agency?.primaryRole === AppConstants.userAgencyType.sale)
                  Utils.openInNewTab(`${AppRoute.saleList}/${row?.agencyId}`);
                else if (row?.agency?.primaryRole === AppConstants.userAgencyType.investor)
                  Utils.openInNewTab(`${AppRoute.investorList}/${row?.agencyId}`);
                else if (row?.agency?.primaryRole === AppConstants.userAgencyType.group)
                  Utils.openInNewTab(`${AppRoute.groupList}/${row?.agencyId}`);
                else Utils.openInNewTab(`${AppRoute.landlordList}/${row?.agencyId}`);
              }}
            >
              {row?.agency?.name ?? ''}
            </span>
          );
        },
        style: tableStyle.columns.link,
      },
      {
        id: 'ROLE',
        name: (
          <span
            className="letter-spacing-unset font-weight-bolder"
            style={{
              fontSize: 12,
              color: AppColors.gray[900],
            }}
          >
            {t('Vai trò')}
          </span>
        ),
        selector: (row) => t(`agencyRoleDropdownTitle_${row?.agency?.primaryRole}`) ?? '',
        width: '160px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'BANK_BENEFICIARY',
        name: (
          <span
            className="letter-spacing-unset"
            style={{
              fontSize: 12,
              color: AppColors.gray[900],
            }}
          >
            {t('Người thụ hưởng')}
          </span>
        ),
        selector: (row) => row?.bankBeneficiary ?? '',
        minWidth: '240px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'BANK_ACCOUNT',
        name: (
          <span
            className="letter-spacing-unset"
            style={{
              fontSize: 12,
              color: AppColors.gray[900],
            }}
          >
            {t('Tài khoản thụ hưởng')}
          </span>
        ),
        selector: (row) => row?.bankAccount ?? '',
        width: '200px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'BANK_NAME',
        name: (
          <span
            className="letter-spacing-unset"
            style={{
              fontSize: 12,
              color: AppColors.gray[900],
            }}
          >
            {t('Ngân hàng')}
          </span>
        ),
        selector: (row) => row?.bankName ?? '',
        minWidth: '240px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'AMOUNT',
        name: (
          <div className="w-100 d-flex flex-column align-items-end">
            <div
              className="letter-spacing-unset"
              style={{
                fontSize: 12,
                color: AppColors.gray[900],
              }}
            >
              {t('Số tiền')}
            </div>
            <div
              className="letter-spacing-unset font-weight-bold"
              style={{ color: AppColors.gray[700] }}
            >
              VNĐ
            </div>
          </div>
        ),
        selector: (row) => (row?.amount != null ? '-' + Utils.formatNumber(row?.amount) : ''),
        width: '160px',
        right: true,
        style: tableStyle.columns.danger,
      },
      {
        id: 'REQUIRE_TIME',
        name: (
          <span
            className="letter-spacing-unset"
            style={{
              fontSize: 12,
              color: AppColors.gray[900],
            }}
          >
            {t('Thời gian yêu cầu')}
          </span>
        ),
        selector: (row) => Utils.formatDateTimeToString(row?.createdAt, 'DD/MM/YYYY - HH:mm'),
        width: '160px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'PAID_TIME',
        name: (
          <span
            className="letter-spacing-unset"
            style={{
              fontSize: 12,
              color: AppColors.gray[900],
            }}
          >
            {t('Thời gian thanh toán')}
          </span>
        ),
        selector: (row) => Utils.formatDateTimeToString(row?.time, 'DD/MM/YYYY - HH:mm'),
        width: '160px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'STATUS',
        name: (
          <span
            className="letter-spacing-unset"
            style={{
              fontSize: 12,
              color: AppColors.gray[900],
            }}
          >
            {t('status')}
          </span>
        ),
        selector: (row) => {
          return (
            <KTLabel
              text={AgencyHelper.Utils.getAgencyPaymentStatusName(row.status)}
              isInline={true}
              size={KTLabelSize.medium}
              additionalClassName={`label-light-${AgencyHelper.Utils.getAgencyPaymentStatusColor(
                row.status
              )}`}
              additionalDescription={row?.reason ?? ''}
            />
          );
        },
        sortable: false,
        width: '130px',
        style: tableStyle.columns.normal,
      },
      {
        name: (
          <span
            style={{
              fontSize: 12,
              color: AppColors.gray[900],
            }}
            className="letter-spacing-unset"
          >
            {t('Thao tác')}
          </span>
        ),
        width: '130px',
        style: {
          position: 'sticky',
          right: 0,
          backgroundColor: '#fff',
          borderLeft: '1px solid #ebedfe',
        },
        cell: (row) => {
          return (
            <MenuActionDropdown
              menuAction={[
                {
                  iconElement: <i className="fa-regular fa-eye" style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}></i>,
                  text: t('Xem chi tiết'),
                  click: () => {
                    handleShowTransactionDetail(row);
                  },
                  show: true,
                },
                {
                  iconElement: <i className="fas fa-check-circle" style={{ color: AppColors.primary, fontSize: '1.1rem' }}></i>,
                  text: t('Phê duyệt'),
                  click: () => {
                    handleAcceptTransaction(row);
                  },
                  show: row?.status === AppConstants.agencyTransactionStatus.requested,
                },
                {
                  iconElement: <i className="fas fa-times-circle" style={{ color: AppColors.danger, fontSize: '1.1rem' }}></i>,
                  text: t('Từ chối'),
                  click: () => {
                    handleRejectTransaction(row);
                  },
                  show: row?.status === AppConstants.agencyTransactionStatus.requested,
                },
                {
                  iconElement: <i className="far fa-money-check-dollar-pen" style={{ color: AppColors.gray[600], fontSize: '1.1rem' }}></i>,
                  text: t('Đã thanh toán'),
                  click: () => {
                    handlePaidConfirm(row);
                  },
                  show: row?.status === AppConstants.agencyTransactionStatus.processing,
                },
              ]}
            />
          );
        },
      },
    ];
  }, [t, account]);
  const { isGettingData, agencyTransactionList, total } = useSelector(
    (state) => state.agencyTransaction
  );
  const [filter, setFilter] = useState(Global.g_filterAgencyTransactionList);
  const [filterDropdown, setFilterDropdown] = useState(Global.g_filterAgencyTransactionList);
  const [agencyList, setAgencyList] = useState([]);

  const prefKey = useMemo(() => {
    const userId = user.userId;
    const pathName = `${router.pathname}${router.location.hash}`;
    const key = `${userId}_${pathName}`;
    return key;
  }, [user, router]);
  const [fullColumnIds, setFullColumnIds] = useState(
    fullColumns.filter(column => !column.omit).map(column => column.id).filter(Boolean) || []
  );
  const {
    columnIds,
    columns,
    onChangeCheckboxValue,
    saveChanges,
    resetDefaultTableColumn,
    onSelectAll,
    onUnSelectAll,
    fullColumnsSorted,
    fullColumnsIdSorted,
  } = useConfigTableColumn(prefKey, fullColumnIds, defaultColumnIds, fullColumns);

  // ---- methods ----

  useEffect(() => {
    if (user?.agency?.agencyId) {
      getAgencyTransactionList();
    }
  }, [filter, user]);

  const getAgencyTransactionList = () => {
    AgencyTransactionHelper.callApiGetAgencyTransactionList({ ...filter });
  };

  const classifyAgencies = (agencies) => {
    if (!agencies) return;

    const agencyList = agencies?.map((agency) => ({
      agencyId: agency.agencyId,
      name: agency.name,
      subAgencies: agency.subAgencies?.map((subAgency) => ({
        agencyId: subAgency.agencyId,
        name: subAgency.name,
      })),
    }));

    setAgencyList(agencyList);
  };

  useEffect(() => {
    const handleGetAgencyList = async () => {
      if (user?.agency?.agencyId) {
        const { tree } = await DealerHelper.callApiGetAgencyTree(user?.agency?.agencyId, { type: 'SALE' });

        if (tree?.subAgencies) {
          classifyAgencies(tree.subAgencies);
        }
      }
    };
    handleGetAgencyList();
  }, [user]);

  const handleShowTransactionDetail = (row) => {
    AppCustomDialogHelper.show(
      'Thông tin giao dịch',
      <AgencyTransactionDetailView
        item={row}
        onClosed={() => {
          AppCustomDialogHelper.hide();
        }}
        onApproved={() => {
          handleAcceptTransaction(row);
        }}
        onRejected={() => {
          handleRejectTransaction(row);
        }}
      />,
      'lg'
    );
  };

  // phe duyet
  const handleAcceptTransaction = (row) => {
    AppCustomDialogHelper.show(
      '',
      <AgencySaleDialogView
        iconEl={<img src={AppResource.images.dialogIcons.dialogSuccess} />}
        title="Phê duyệt giao dịch"
        contentEl={
          <>
            Bạn có chắc muốn phê duyệt giao dịch {' '}
            <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}>
              {row?.paymentCode ?? row?.paymentId}{' '}
            </span>
            không?
          </>
        }
        onCancel={() => {
          AppCustomDialogHelper.hide();
        }}
        onConfirm={async () => {
          const res = await AgencyTransactionHelper.callApiUpdateAgencyTransaction({
            paymentId: row?.paymentId,
            status: 'PROCESSING',
          });

          if (res && _.isBoolean(res)) {
            ToastHelper.showSuccess('Phê duyệt thành công');
            getAgencyTransactionList();
            AppCustomDialogHelper.hide();
          } else {
            ToastHelper.showError(res || 'Phê duyệt thất bại');
          }
        }}
        confirmButtonText="Phê duyệt"
      />,
      'md',
      false,
      true
    );
  }

  // tu choi
  const handleRejectTransaction = (row) => {
    AppCustomDialogHelper.show(
      '',
      <AgencySaleDialogView
        iconEl={<img src={AppResource.images.dialogIcons.dialogError} />}
        title="Từ chối giao dịch"
        contentEl={
          <>
            Bạn có chắc muốn từ chối giao dịch {' '}
            <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}>
              {row?.paymentCode ?? row?.paymentId}
            </span>
            {' '} không?
          </>
        }
        inputLabel={['Lý do']}
        showInput={true}
        isFormTextArea={true}
        onCancel={() => {
          AppCustomDialogHelper.hide();
        }}
        onConfirm={async (values) => {
          const [reason] = values;
          const res = await AgencyTransactionHelper.callApiUpdateAgencyTransaction({
            paymentId: row?.paymentId,
            status: 'REJECTED',
            reason: reason,
          });
          if (res && _.isBoolean(res)) {
            ToastHelper.showSuccess(t('Từ chối thành công'));
            getAgencyTransactionList();
            AppDialogHelper.hide();
            AppCustomDialogHelper.hide();
          } else {
            ToastHelper.showError(res || 'Từ chối thất bại');
          }
        }}
        confirmButtonRed={true}
        confirmButtonText="Từ chối"
      />,
      'md',
      false,
      true
    );
  };

  // da thanh toan
  const handlePaidConfirm = (row) => {
    AppCustomDialogHelper.show(
      '',
      <AgencySaleDialogView
        iconEl={<img src={AppResource.images.dialogIcons.dialogSetChargingPrice} />}
        title="Đã thanh toán"
        contentEl={
          <>
            Xác nhận đã thanh toán giao dịch {' '}
            <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}>
              {row?.paymentCode ?? row?.paymentId}
            </span>
            {' '}?
          </>
        }
        inputLabel={['Lý do']}
        showInput={false}
        onCancel={() => {
          AppCustomDialogHelper.hide();
        }}
        onConfirm={async (values) => {
          const res = await AgencyTransactionHelper.callApiUpdateAgencyTransaction({
            paymentId: row?.paymentId,
            status: 'PAID',
          });
          if (res && _.isBoolean(res)) {
            ToastHelper.showSuccess(t('Xác nhận đã thanh toán thành công'));
            getAgencyTransactionList();
            AppDialogHelper.hide();
            AppCustomDialogHelper.hide();
          } else {
            ToastHelper.showError(res || 'Xác nhận đã thanh toán thất bại');
          }
        }}
        confirmButtonText="Xác nhận"
      />,
      'md',
      false,
      true
    );
  };

  // xuat file excel
  const handleExportExcel = async (exportData, params) => {
    let exportDataList = exportData;
    if (_.isEmpty(exportDataList)) {
      ToastHelper.showError('Không có dữ liệu để tải xuống');
      return;
    }

    const sheetFileName = 'Yêu_cầu_rút_tiền_của_đối_tác_' + moment(params.from).format('DDMMYYYY') + '_' + moment(params.to).format('DDMMYYYY');
    const ext = '.xlsx';
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet(sheetFileName, {
      headerFooter: { firstHeader: sheetFileName },
    });

    sheet.mergeCells('A1:M1');
    sheet.getCell('A1').value = `DANH SÁCH YÊU CẦU RÚT TIỀN CỦA ĐỐI TÁC _(NGÀY ${moment(params.from).format(
      'DD/MM/YYYY'
    )} - ${moment(params.to).format('DD/MM/YYYY')})`;
    sheet.getCell('A1').font = {
      name: 'Times New Roman',
      family: 4,
      size: 11,
      bold: true,
      color: { argb: 'FFFFFFFF' },
    };
    sheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
    sheet.getCell('A1').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: '29618E' },
      color: { argb: 'FFFFFF' },
    };
    sheet.getCell('A1').border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
    sheet.getRow(1).height = 25;

    const columns = [
      { key: 'stt', width: 7 },
      { key: 'transactionCode', width: 18 },
      { key: 'agencyName', width: 25 },
      { key: 'agencyRole', width: 22 },
      { key: 'agencyCode', width: 22 },
      { key: 'bankBeneficiary', width: 30 },
      { key: 'bankAccount', width: 22 },
      { key: 'bankName', width: 22 },
      { key: 'amount', width: 15 },
      { key: 'balance', width: 20 },
      { key: 'status', width: 20 },
      { key: 'requestTime', width: 20 },
      { key: 'finishTime', width: 20 },
    ];
    sheet.columns = columns;

    sheet.getRow(2).height = 30;
    sheet.getRow(2).font = {
      name: 'Times New Roman',
      family: 4,
      size: 11,
      bold: true,
    };
    sheet.getRow(2).alignment = {
      vertical: 'middle',
      horizontal: 'center',
      wrapText: true,
    };

    sheet.getCell('A2').value = 'STT';
    sheet.getCell('B2').value = 'Mã giao dịch';
    sheet.getCell('C2').value = 'Người yêu cầu';
    sheet.getCell('D2').value = 'Vai trò';
    sheet.getCell('E2').value = 'Mã đối tác';
    sheet.getCell('F2').value = 'Người thụ hưởng';
    sheet.getCell('G2').value = 'Tài khoản thụ hưởng';
    sheet.getCell('H2').value = 'Ngân hàng';
    sheet.getCell('I2').value = 'Số tiền (VNĐ)';
    sheet.getCell('J2').value = 'Số dư ví (VNĐ)';
    sheet.getCell('K2').value = 'Trạng thái';
    sheet.getCell('L2').value = 'Thời gian yêu cầu';
    sheet.getCell('M2').value = 'Thời gian thanh toán';


    ['A2:M2'].forEach((range) => {
      sheet.getRow(range.split(':')[0].slice(1)).eachCell({ includeEmpty: true }, (cell) => {
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
      });
    });

    let i = 1;
    exportDataList?.forEach((row) => {
      const dataRow = sheet.addRow({
        stt: i++,
        transactionCode: row?.paymentCode ?? row?.paymentId,
        agencyName: row?.agency?.name ?? '',
        agencyRole: t(`agencyRoleDropdownTitle_${row?.agency?.primaryRole}`) ?? '',
        agencyCode: row?.agency?.agencyCode ?? agency?.agency?.agencyId,
        bankBeneficiary: row?.bankBeneficiary ?? '',
        bankAccount: row?.bankAccount ?? '',
        bankName: row?.bankName ?? '',
        amount: Utils.formatNumber(row?.amount ?? 0),
        balance: Utils.formatNumber(row?.agency?.balance ?? 0),
        status: t(`agencyPaymentStatus_${row.status}`),
        requestTime: Utils.formatDateTimeToString(row?.createdAt),
        finishTime: Utils.formatDateTimeToString(row?.time),
      });

      dataRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
        if (colNumber === 1) {
          cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
        } else if (colNumber >= 9 && colNumber <= 10) {
          cell.alignment = { vertical: 'middle', horizontal: 'right', wrapText: true };
        } else {
          cell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
        }
      });
    });

    sheet.eachRow((row, rowNumber) => {
      if (rowNumber >= 3) {
        row.font = {
          name: 'Times New Roman',
          family: 4,
          size: 11,
          bold: false,
        };
      }
    });

    workbook.xlsx.writeBuffer().then(function (data) {
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = sheetFileName + ext;
      anchor.click();
      window.URL.revokeObjectURL(url);
      ToastHelper.showSuccess('Tải xuống file Excel thành công');
      AppCustomDialogHelper.hide();
    });
  };

  return (
    <div>
      <KTBSCard
        borderRadius="10"
        title={t('Yêu cầu rút tiền của đối tác')}
        description={
          <div>
            <span
              className="font-weight-bolder"
              style={{ fontSize: '14px', color: AppColors.gray[800] }}
            >
              {t('total')}:{' '}
            </span>
            <span
              className="font-weight-bolder"
              style={{ fontSize: '14px', color: AppColors.primary }}
            >
              {total != 0 ? total : agencyTransactionList?.length} {t('giao dịch').toLowerCase()}
            </span>
          </div>
        }
        additionalHeaderClassName="pt-4 pb-2"
        additionalBodyClassName=""
        additionalFooterClassName=""
        hideDividerHeader
        hideDividerFooter
        toolbar={
          <div className="d-flex gap-3">
            {UIHelper.buildBlueButton(
              'Tải xuống',
              async () => {
                try {
                  ChargeHelper.UI.Excel.showDialogDownloadExcelFile(
                    Global.g_filterAgencyTransactionList,
                    async (params) => {
                      try {
                        const { requests = [] } = await agencyApi.getAgencyWithdrawTransaction(params);
                        return handleExportExcel(requests, params);
                      } catch (error) {
                        ToastHelper.showError(`Lỗi khi lấy dữ liệu: ${error.message}`);
                        return [];
                      }
                    },
                  );
                } catch (error) {
                  ToastHelper.showError(`Lỗi khi khởi tạo tải xuống: ${error.message}`);
                }
              },
              <i className="fa-regular fa-download" style={{ fontSize: 15 }} />
            )}
          </div>
        }
        subToolbar={
          <div className="w-100 d-flex align-items-end flex-wrap">
            <div className="col-lg-3 col-sm-6 px-0 pr-sm-4 py-2">
              <label htmlFor="search" className="mb-0 mr-2 font-weight-bolder">
                {t('search')}
              </label>
              <KTFormSearch
                name="search-bar"
                placeholder={t('Theo mã giao dịch, người thụ hưởng...')}
                value={Global.g_filterAgencyTransactionList.q}
                onSubmit={(text) => {
                  Global.g_filterAgencyTransactionList = {
                    ...Global.g_filterAgencyTransactionList,
                    q: text,
                  };
                  setFilter(Global.g_filterAgencyTransactionList);
                }}
              />
            </div>
            <div className="col-lg-3 col-sm-6 px-0 pr-lg-4 py-2">
              <label htmlFor="operator" className="mb-0 mr-2 font-weight-bolder">
                {t('Đại lý')}
              </label>
              <KTBSDropdown
                toggleElement={
                  <button
                    className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                    type="button"
                  >
                    {agencyList.find(
                      (agency) => agency.agencyId === Global.g_filterAgencyTransactionList.agencyId
                    )?.name ?? t('all')}
                  </button>
                }
                selectedValue={Global.g_filterAgencyTransactionList.agencyId}
                dropdownMenuItems={[
                  { name: t('all'), value: '' },
                  ...agencyList?.map((agency) => ({
                    name: agency.name,
                    value: agency.agencyId,
                  })),
                ]}
                dropdownMenuClassName="overflow-auto w-100"
                dropdownMenuStyle={{ maxHeight: '30vh' }}
                onChange={(value) => {
                  Global.g_filterAgencyTransactionList = {
                    ...Global.g_filterAgencyTransactionList,
                    agencyId: value,
                  };
                  setFilter(Global.g_filterAgencyTransactionList);
                }}
                isDropdownForm={true}
                searchable={true}
                searchFormClassName="mx-3 my-1 search-form-border"
              />
            </div>
            {/* <div className="col-lg-3 col-sm-6 px-0 pr-lg-4 py-2">
              <label htmlFor="operator" className="mb-0 mr-2 font-weight-bolder">
                {t('Vai trò')}
              </label>
              <KTBSDropdown
                toggleElement={
                  <button
                    className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                    type="button"
                  >
                    {Global.g_filterAgencyTransactionList.forRole
                      ? t(`agencyRoleDropdownTitle_${Global.g_filterAgencyTransactionList.forRole}`)
                      : t('all')}
                  </button>
                }
                selectedValue={Global.g_filterAgencyTransactionList.forRole}
                dropdownMenuItems={CommissionTransactionHelper.filterRoleOptions()}
                dropdownMenuClassName="overflow-auto w-100"
                dropdownMenuStyle={{ maxHeight: '30vh' }}
                onChange={(value) => {
                  Global.g_filterAgencyTransactionList = {
                    ...Global.g_filterAgencyTransactionList,
                    forRole: value,
                  };
                  setFilter(Global.g_filterAgencyTransactionList);
                }}
                isDropdownForm={true}
              />
            </div> */}
            <div className="col-lg-2 col-sm-6 px-0 pr-sm-4 py-2">
              <label htmlFor="operator" className="mb-0 mr-2 font-weight-bolder">
                {t('status')}
              </label>
              <KTBSDropdown
                toggleElement={
                  <button
                    className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                    type="button"
                  >
                    {Global.g_filterAgencyTransactionList.status?.length
                      ? t(`agencyPaymentStatus_${Global.g_filterAgencyTransactionList.status}`)
                      : t('all')}
                  </button>
                }
                selectedValue={Global.g_filterAgencyTransactionList.status}
                dropdownMenuItems={AgencyTransactionHelper.filterPaymentStatusOptions()}
                dropdownMenuClassName="overflow-auto w-100"
                dropdownMenuStyle={{ maxHeight: '30vh' }}
                onChange={(value) => {
                  Global.g_filterAgencyTransactionList = {
                    ...Global.g_filterAgencyTransactionList,
                    status: value,
                  };
                  setFilter(Global.g_filterAgencyTransactionList);
                }}
                isDropdownForm={true}
              />
            </div>
            {/* khoang thoi gian */}
            <div className="col-lg-2 col-sm-6 px-0 pr-lg-4 py-2">
              <label htmlFor="filterByDate" className="mb-0 mr-2 font-weight-bolder">
                {t('filterByDate')}
              </label>
              <CustomDateRangePicker
                toggleElementBorderRadius={5}
                alignRight={true}
                initialValue={
                  Global.g_filterAgencyTransactionList.selectedValue?.length > 0
                    ? Global.g_filterAgencyTransactionList.selectedValue
                    : dateFilter.baMuoiNgayGanNhat
                }
                onPressSave={(selectedValue, startDate, endDate) => {
                  Global.g_filterAgencyTransactionList = {
                    ...Global.g_filterAgencyTransactionList,
                    from: startDate,
                    to: endDate,
                    selectedValue: selectedValue,
                  };
                  setFilter(Global.g_filterAgencyTransactionList);
                }}
                filterComponent={Global.g_filterAgencyTransactionList}
              />
            </div>
            {/* cau hinh cot */}
            <div className="pr-0 py-2">
              <DropdownTableConfigColumn
                columnIds={columnIds}
                fullColumns={fullColumns}
                fullColumnIds={fullColumnsIdSorted}
                onChangeCheckboxValue={onChangeCheckboxValue}
                saveChanges={saveChanges}
                resetDefaultTableColumn={() => {
                  setFullColumnIds(defaultColumnIds);
                  resetDefaultTableColumn();
                }}
                onChangeFullColumnIds={(ids) => {
                  setFullColumnIds(ids);
                  const key = prefKey + '_FULL_COLUMN_IDS';
                  localStorage.setItem(key, ids.join('|'));
                }}
                onSelectAll={onSelectAll}
                onUnSelectAll={onUnSelectAll}
              />
            </div>
          </div>
        }
        footer={
          <KTPagination
            currentPage={filter.page + 1}
            rowCount={total != 0 ? total : agencyTransactionList?.length}
            rowsPerPage={filter.limit}
            currentItemInPageCount={agencyTransactionList?.length}
            onChangePage={(newPage) => {
              const iNewPage = parseInt(newPage);
              Global.g_filterAgencyTransactionList = {
                ...Global.g_filterAgencyTransactionList,
                page: iNewPage - 1,
              };
              setFilter(Global.g_filterAgencyTransactionList);
            }}
            onChangeRowsPerPage={(newRowsPerPage) => {
              const iNewRowsPerPage = parseInt(newRowsPerPage);
              Global.g_filterAgencyTransactionList = {
                ...Global.g_filterAgencyTransactionList,
                limit: iNewRowsPerPage,
                page: 0,
              };
              setFilter(Global.g_filterAgencyTransactionList);
            }}
            loading={isGettingData}
            color={KTPaginationColor.success}
            appendText="giao dịch"
          />
        }
        body={
          <KTTable
            columns={columns}
            items={agencyTransactionList}
            selectableRows={false}
            striped={false}
            compactGrid={false}
            onClickedRow={(row) => { }}
            onSelectedRowsChanged={(rows) => { }}
            onDoubleClickedRow={(rows) => { }}
            noDataComponent={
              <EmptyView
                icon={imgEmptyThanhToan}
                title="Không có dữ liệu để hiển thị"
                text={<span>Vui lòng kiểm tra kết nối mạng hoặc tải lại trang.</span>}
              />
            }
          />
        }
      />
    </div>
  );
}

export default AgencyTransactionListScreen;
